import React from 'react'

export default function AboutList(props){
    return (
        <li>
            <span className="list-title list-inline-item">{props.name} :</span>
            <span> {props.value}</span>
        </li>
    )
}